/* eslint-disable */
const colorTokens = {
  'core-tokens': {
    '$ui-background': {
      role: ['Default page background'],
      value: {
        white: {
          name: 'White',
          hex: '#ffffff',
        },
        g10: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g90: {
          name: 'Gray 90',
          hex: '#282828',
        },
        g100: {
          name: 'Gray 100',
          hex: '#171717',
        },
      },
    },
    '$interactive-01': {
      role: ['Primary interactive color', 'Primary buttons'],
      value: {
        white: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g10: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g90: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g100: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
      },
    },
    '$interactive-02': {
      role: ['Secondary interactive color', 'Secondary button'],
      value: {
        white: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g10: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g90: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
        g100: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
      },
    },
    '$interactive-03': {
      role: ['4.5:1 AA contrast', 'Tertiary button'],
      value: {
        white: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g10: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g90: {
          name: 'White',
          hex: '#ffffff',
        },
        g100: {
          name: 'White',
          hex: '#ffffff',
        },
      },
    },
    '$interactive-04': {
      role: [
        '3:1 AA contrast',
        'Selected elements',
        'Active elements',
        'Accent icons',
      ],
      value: {
        white: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g10: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g90: {
          name: 'Blue 50',
          hex: '#408bfc',
        },
        g100: {
          name: 'Blue 50',
          hex: '#408bfc',
        },
      },
    },
    '$ui-01': {
      role: ['Primary container background', 'Secondary page background'],
      value: {
        white: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g10: {
          name: 'White',
          hex: '#ffffff',
        },
        g90: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
        g100: {
          name: 'Gray 90',
          hex: '#282828',
        },
      },
    },
    '$ui-02': {
      role: ['Primary page background', 'Secondary container background'],
      value: {
        white: {
          name: 'White',
          hex: '#ffffff',
        },
        g10: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g90: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g100: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
      },
    },
    '$ui-03': {
      role: ['Subtle border', 'Tertiary background color'],
      value: {
        white: {
          name: 'Gray 20',
          hex: '#dcdcdc',
        },
        g10: {
          name: 'Gray 20',
          hex: '#dcdcdc',
        },
        g90: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g100: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
      },
    },
    '$ui-04': {
      role: ['3:1 AA element contrast', 'Medium contrast border'],
      value: {
        white: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g10: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g90: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g100: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
      },
    },
    '$ui-05': {
      role: [
        '4.5:1 AA element contrast',
        'High contrast border',
        'Emphasis elements',
      ],
      value: {
        white: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g10: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g90: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g100: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
      },
    },
    '$text-01': {
      role: [
        'Primary text',
        'Body copy',
        'Headers',
        'Hover text color for text-02',
      ],
      value: {
        white: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g10: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g90: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g100: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
      },
    },
    '$text-02': {
      role: ['Secondary text', 'Input labels', 'Help text'],
      value: {
        white: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g10: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g90: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g100: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
      },
    },
    '$text-03': {
      role: ['Placeholder text'],
      value: {
        white: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g10: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g90: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g100: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
      },
    },
    '$text-04': {
      role: ['Text on interactive colors'],
      value: {
        white: {
          name: 'White',
          hex: '#ffffff',
        },
        g10: {
          name: 'White',
          hex: '#ffffff',
        },
        g90: {
          name: 'White',
          hex: '#ffffff',
        },
        g100: {
          name: 'White',
          hex: '#ffffff',
        },
      },
    },
    '$link-01': {
      role: ['Primary links', 'Ghost button'],
      value: {
        white: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g10: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g90: {
          name: 'Blue 40',
          hex: '#6ea6ff',
        },
        g100: {
          name: 'Blue 40',
          hex: '#6ea6ff',
        },
      },
    },
    '$icon-01': {
      role: ['Primary icons'],
      value: {
        white: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g10: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g90: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g100: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
      },
    },
    '$icon-02': {
      role: ['Secondary icons'],
      value: {
        white: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g10: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g90: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g100: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
      },
    },
    '$icon-03': {
      role: [
        'Tertiary icons',
        `Icons on interactive colors`,
        `Icons on non-ui colors`,
      ],
      value: {
        white: {
          name: 'White',
          hex: '#ffffff',
        },
        g10: {
          name: 'White',
          hex: '#ffffff',
        },
        g90: {
          name: 'White',
          hex: '#ffffff',
        },
        g100: {
          name: 'White',
          hex: '#ffffff',
        },
      },
    },
    '$field-01': {
      role: ['Default input fields', 'Field color on $ui-backgrounds'],
      value: {
        white: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g10: {
          name: 'White',
          hex: '#ffffff',
        },
        g90: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
        g100: {
          name: 'Gray 90',
          hex: '#282828',
        },
      },
    },
    '$field-02': {
      role: ['Input field color on $ui-02 backgrounds'],
      value: {
        white: {
          name: 'White',
          hex: '#ffffff',
        },
        g10: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g90: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g100: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
      },
    },
    '$inverse-01': {
      role: ['Inverse text color', 'Inverse icon color'],
      value: {
        white: {
          name: 'White',
          hex: '#ffffff',
        },
        g10: {
          name: 'White',
          hex: '#ffffff',
        },
        g90: {
          name: 'Gray 100',
          hex: '#171717',
        },
        g100: {
          name: 'Gray 100',
          hex: '#171717',
        },
      },
    },
    '$inverse-02': {
      role: ['High contrast backgrounds', 'High contrast elements'],
      value: {
        white: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
        g10: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
        g90: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g100: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
      },
    },
    '$support-01': {
      role: ['Error'],
      value: {
        white: {
          name: 'Red 60',
          hex: '#da1e28',
        },
        g10: {
          name: 'Red 60',
          hex: '#da1e28',
        },
        g90: {
          name: 'Red 50',
          hex: '#fb4b53',
        },
        g100: {
          name: 'Red 50',
          hex: '#fb4b53',
        },
      },
    },
    '$support-02': {
      role: ['Success'],
      value: {
        white: {
          name: 'Green 50',
          hex: '#24a148',
        },
        g10: {
          name: 'Green 50',
          hex: '#24a148',
        },
        g90: {
          name: 'Green 40',
          hex: '#3dbb61',
        },
        g100: {
          name: 'Green 40',
          hex: '#3dbb61',
        },
      },
    },
    '$support-03': {
      role: ['Warning'],
      value: {
        white: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
        g10: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
        g90: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
        g100: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
      },
    },
    '$support-04': {
      role: ['Information'],
      value: {
        white: {
          name: 'Blue 70',
          hex: '#054ada',
        },
        g10: {
          name: 'Blue 70',
          hex: '#054ada',
        },
        g90: {
          name: 'Blue 50',
          hex: '#408bfc',
        },
        g100: {
          name: 'Blue 50',
          hex: '#408bfc',
        },
      },
    },
    '$inverse-support-01': {
      role: ['Danger in high contrast moments'],
      value: {
        white: {
          name: 'Red 50',
          hex: '#fb4b53',
        },
        g10: {
          name: 'Red 50',
          hex: '#fb4b53',
        },
        g90: {
          name: 'Red 60',
          hex: '#da1e28',
        },
        g100: {
          name: 'Red 60',
          hex: '#da1e28',
        },
      },
    },
    '$inverse-support-02': {
      role: ['Success in high contrast moments'],
      value: {
        white: {
          name: 'Green 40',
          hex: '#3dbb61',
        },
        g10: {
          name: 'Green 40',
          hex: '#3dbb61',
        },
        g90: {
          name: 'Green 50',
          hex: '#24a148',
        },
        g100: {
          name: 'Green 50',
          hex: '#24a148',
        },
      },
    },
    '$inverse-support-03': {
      role: ['Warning in high contrast moments'],
      value: {
        white: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
        g10: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
        g90: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
        g100: {
          name: 'Yellow',
          hex: '#fdd13a',
        },
      },
    },
    '$inverse-support-04': {
      role: ['Information in high contrast moments'],
      value: {
        white: {
          name: 'Blue 50',
          hex: '#408bfc',
        },
        g10: {
          name: 'Blue 50',
          hex: '#408bfc',
        },
        g90: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g100: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
      },
    },
    '$overlay-01': {
      role: ['Background overlay'],
      value: {
        white: {
          name: 'Gray 100',
          hex: '#171717 @ 50%',
        },
        g10: {
          name: 'Gray 100',
          hex: '#171717 @ 50%',
        },
        g90: {
          name: 'Gray 100',
          hex: '#171717 @ 70%',
        },
        g100: {
          name: 'Gray 100',
          hex: '#171717 @ 70%',
        },
      },
    },
  },
  'interaction-tokens': {
    $focus: {
      role: ['Focus border', 'Focus underline'],
      value: {
        white: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g10: {
          name: 'Blue 60',
          hex: '#0062ff',
        },
        g90: {
          name: 'White',
          hex: '#ffffff',
        },
        g100: {
          name: 'White',
          hex: '#ffffff',
        },
      },
    },
    '$hover-primary': {
      role: ['$interactive-01 hover'],
      value: {
        white: {
          name: 'Blue 60 hover',
          hex: '#0353e9',
        },
        g10: {
          name: 'Blue 60 hover',
          hex: '#0353e9',
        },
        g90: {
          name: 'Blue 60 hover',
          hex: '#0353e9',
        },
        g100: {
          name: 'Blue 60 hover',
          hex: '#0353e9',
        },
      },
    },
    '$hover-primary-text': {
      role: ['$interactive-01 text hover'],
      value: {
        white: {
          name: 'Blue 70',
          hex: '#054ada',
        },
        g10: {
          name: 'Blue 70',
          hex: '#054ada',
        },
        g90: {
          name: 'Blue 70',
          hex: '#054ada',
        },
        g100: {
          name: 'Blue 70',
          hex: '#054ada',
        },
      },
    },
    '$hover-secondary': {
      role: ['$interactive-02 hover'],
      value: {
        white: {
          name: 'Gray 80 hover',
          hex: '#4c4c4c',
        },
        g10: {
          name: 'Gray 80 hover',
          hex: '#4c4c4c',
        },
        g90: {
          name: 'Gray 60 hover',
          hex: '#606060',
        },
        g100: {
          name: 'Gray 60 hover',
          hex: '#606060',
        },
      },
    },
    '$hover-tertiary': {
      role: ['$interactive-03 hover', '$inverse-01 hover'],
      value: {
        white: {
          name: 'Blue 60 hover',
          hex: '#0353e9',
        },
        g10: {
          name: 'Blue 60 hover',
          hex: '#0353e9',
        },
        g90: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g100: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
      },
    },
    '$hover-ui': {
      role: ['$ui-01 hover', '$ui-02 hover', 'Transparent background hover'],
      value: {
        white: {
          name: 'Gray 10 hover',
          hex: '#e5e5e5',
        },
        g10: {
          name: 'Gray 10 hover',
          hex: '#e5e5e5',
        },
        g90: {
          name: 'Gray 80 hover',
          hex: '#4c4c4c',
        },
        g100: {
          name: 'Gray 90 hover',
          hex: '#353535',
        },
      },
    },
    '$hover-selected-ui': {
      role: ['Selected row hover'],
      value: {
        white: {
          name: 'Gray 20 hover',
          hex: '#cacaca',
        },
        g10: {
          name: 'Gray 20 hover',
          hex: '#cacaca',
        },
        g90: {
          name: 'Gray 70 hover',
          hex: '#656565',
        },
        g100: {
          name: 'Gray 80 hover',
          hex: '#4c4c4c',
        },
      },
    },
    '$hover-danger': {
      role: ['Danger hover', '$support-01 hover'],
      value: {
        white: {
          name: 'Red 60 hover',
          hex: '#ba1b23',
        },
        g10: {
          name: 'Red 60 hover',
          hex: '#ba1b23',
        },
        g90: {
          name: 'Red 60 hover',
          hex: '#ba1b23',
        },
        g100: {
          name: 'Red 60 hover',
          hex: '#ba1b23',
        },
      },
    },
    '$hover-row': {
      role: ['Row hover'],
      value: {
        white: {
          name: 'Gray 10 hover',
          hex: '#e5e5e5',
        },
        g10: {
          name: 'Gray 10 hover',
          hex: '#e5e5e5',
        },
        g90: {
          name: 'Gray 80 hover',
          hex: '#4c4c4c',
        },
        g100: {
          name: 'Gray 90 hover',
          hex: '#353535',
        },
      },
    },
    '$active-primary': {
      role: ['$interactive-01 active'],
      value: {
        white: {
          name: 'Blue 80',
          hex: '#0530ad',
        },
        g10: {
          name: 'Blue 80',
          hex: '#0530ad',
        },
        g90: {
          name: 'Blue 80',
          hex: '#0530ad',
        },
        g100: {
          name: 'Blue 80',
          hex: '#0530ad',
        },
      },
    },
    '$active-secondary': {
      role: ['$interactive-02 active', '$inverse-01 active'],
      value: {
        white: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
        g10: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
        g90: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
        g100: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
      },
    },
    '$active-tertiary': {
      role: ['$interactive-03 active'],
      value: {
        white: {
          name: 'Blue 80',
          hex: '#0530ad',
        },
        g10: {
          name: 'Blue 80',
          hex: '#0530ad',
        },
        g90: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g100: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
      },
    },
    '$active-ui': {
      role: ['$ui-01 active', '$ui-02 active'],
      value: {
        white: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g10: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g90: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
        g100: {
          name: 'Gray 70',
          hex: '#565656',
        },
      },
    },
    '$active-danger': {
      role: ['Danger active', '$support-01 active'],
      value: {
        white: {
          name: 'Red 80',
          hex: '#750e13',
        },
        g10: {
          name: 'Red 80',
          hex: '#750e13',
        },
        g90: {
          name: 'Red 80',
          hex: '#750e13',
        },
        g100: {
          name: 'Red 80',
          hex: '#750e13',
        },
      },
    },
    '$selected-ui': {
      role: ['Selected UI elements'],
      value: {
        white: {
          name: 'Gray 20',
          hex: '#dcdcdc',
        },
        g10: {
          name: 'Gray 20',
          hex: '#dcdcdc',
        },
        g90: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g100: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
      },
    },
    $highlight: {
      role: ['$interactive-01 highlight'],
      value: {
        white: {
          name: 'Blue 20',
          hex: '#C9deff',
        },
        g10: {
          name: 'Blue 10',
          hex: '#edf4ff',
        },
        g90: {
          name: 'Blue 80',
          hex: '#0530ad',
        },
        g100: {
          name: 'Blue 90',
          hex: '#051b75',
        },
      },
    },
    '$skeleton-01': {
      role: ['Skeleton state of graphics'],
      value: {
        white: {
          name: 'Gray 10 hover',
          hex: '#e5e5e5',
        },
        g10: {
          name: 'Gray 10 hover',
          hex: '#e5e5e5',
        },
        g90: {
          name: 'Gray 80 hover',
          hex: '#353535',
        },
        g100: {
          name: 'Gray 80 hover',
          hex: '#353535',
        },
      },
    },
    '$skeleton-02': {
      role: ['Skeleton state of texts'],
      value: {
        white: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g10: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g90: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g100: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
      },
    },
    '$visited-link': {
      role: ['Visited links'],
      value: {
        white: {
          name: 'Purple 60',
          hex: '#8a3ffc',
        },
        g10: {
          name: 'Purple 60',
          hex: '#8a3ffc',
        },
        g90: {
          name: 'Purple 40',
          hex: '#bb8eff',
        },
        g100: {
          name: 'Purple 40',
          hex: '#bb8eff',
        },
      },
    },
    '$disabled-01': {
      role: ['Disabled fields', 'Disabled backgrounds', 'Disabled border'],
      value: {
        white: {
          name: 'Gray 10',
          hex: '#f3f3f3',
        },
        g10: {
          name: 'White',
          hex: '#ffffff',
        },
        g90: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
        g100: {
          name: 'Gray 90',
          hex: '#282828',
        },
      },
    },
    '$disabled-02': {
      role: [
        'Disabled elements on $disabled-01',
        'Disabled label',
        'Disabled text on $disabled-01',
        'Disabled icons',
        'Disabled border',
      ],
      value: {
        white: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g10: {
          name: 'Gray 30',
          hex: '#bebebe',
        },
        g90: {
          name: 'Gray 70',
          hex: '#565656',
        },
        g100: {
          name: 'Gray 80',
          hex: '#3d3d3d',
        },
      },
    },
    '$disabled-03': {
      role: ['Disabled text on $disabled-02', 'Disabled icons on $disabled-02'],
      value: {
        white: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g10: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g90: {
          name: 'Gray 50',
          hex: '#8c8c8c',
        },
        g100: {
          name: 'Gray 60',
          hex: '#6f6f6f',
        },
      },
    },
  },
};

export default colorTokens;
